export function TermsPage() {
  return (
    <div className="kt-prose">
      <h1 className="ab-h1" style={{ color: "var(--kt-ink)" }}>Terms of Service</h1>
      <p style={{ fontSize: 13, color: "var(--kt-text-muted)" }}>Last updated: March 2026</p>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Use of the service</h2>
        <p>
          Aeronet Brain is a personal knowledge tool. You may use it to store and retrieve your own
          thoughts, notes, and memories. You are responsible for the content you capture.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Your content</h2>
        <p>
          You own everything you capture. We do not claim any rights to your content. By using the
          service, you grant us a limited license to store and process your content solely to
          provide the service to you.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Acceptable use</h2>
        <p>You agree not to use Aeronet Brain to store or share illegal content, to attempt to
          access other users' data, or to interfere with the operation of the service.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Availability</h2>
        <p>
          We aim for high availability but do not guarantee uninterrupted service. We may modify
          or discontinue features with reasonable notice.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Limitation of liability</h2>
        <p>
          The service is provided "as is." The maintainers are not liable for any loss of data or
          damages arising from use of the service.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Contact</h2>
        <p>
          Questions?{" "}
          <a href="mailto:hello@example.com" style={{ color: "var(--kt-teal-ink)" }}>
            hello@example.com
          </a>
        </p>
      </section>
    </div>
  );
}
